import request from "../request";

export const getVisitList = (payload) => {
  const url = `/visit/find_by`;
  if (!payload) {
    payload = {};
  }
  return request.post(url, payload);
};
export const getVisitList2 = (url) => {
  return request.get(url);
};

export const getVisitWithId = ({ id }) => {
  const url = `/visit/${id}`;
  return request.get(url);
};

export const getVisitWithFilter = (payload) => {
  const url = `/visit/filter`;
  return request.post(url, payload);
};

export const addVisit = (payload) => {
  const url = "/visit/add";
  return request.post(url, payload);
};

export const createCustomerVisit = (payload) => {
  const url = "/customer-visit/create";
  return request.post(url, payload);
};

export const deleteVisit = ({ id }) => {
  const url = `/visit/${id}`;
  return request.delete(url);
};

export const getVisitComment = (payload) => {
  const url = `/dealer_visit/dealer_visit_filter`;
  return request.post(url, payload);
};

export const addVisitComment = (payload) => {
  const url = `/dealer_visit/add`;
  return request.post(url, payload);
};

export const addVisitRead = (payload) => {
  const url = "/visit_read_status/add";
  return request.post(url, payload);
};


export const exportVisit = (payload) => {
  let url = null;
  if(payload.salesId!=null){
     url = `/visit/export?regionCode=${payload.regionCode}&salesId=${payload.salesId}&start=${payload.start}&end=${payload.end}`;
  }else{    
     url = `/visit/export?regionCode=${payload.regionCode}&salesId=&start=${payload.start}&end=${payload.end}`;
  }
  return request.get(url, {
    responseType: "blob",
  });
};

export const getDealerByName = ( param ) => {
  const url = `/dealer/getDealerByName?name=${param}`;
  return request.post(url);
};


//获取最近拜访的客户联系人及职位
export const getRecentlyContacts = (url) => {
  return request.get(url);
};
